<template>
  <modal-wrapper>
    <modal-container :show-close="false">
      <validation-observer v-slot="{invalid}">
        <div class="register-page__modal-header">
          <img src="@/assets/img/logo.svg" alt="logo" class="page__logo" />
          <language-switcher />
        </div>
        <h3>{{ $t('register.resident-title') }}</h3>
        <div>
          <form-group>
            <validation-provider v-slot="{errors}" rules="required">
              <text-input
                v-model="phone"
                :mask-options="{mask:'+0000000000000000000', placeholderChar:' '}"
                :errors="[...errors, $t(backendErrors.phone)]"
                :label="$t('register.contact-phone')"
                required
                type="text"
              />
            </validation-provider>
            <validation-provider v-slot="{errors}" rules="required|email">
              <text-input
                v-model="email"
                :errors="[...errors, ...backendErrors.email]"
                :label="$t('common.email')"
                placeholder="maximus@gmail.com"
                required
              />
              <span class="email-hint">{{ $t('register.email-hint') }}</span>
            </validation-provider>
          </form-group>
        </div>
        <div class="register-page__modal-buttons vertical">
          <pc-button variant="dark" :disabled="invalid" @click="register">
            {{ $t('application-form.continue') }}
          </pc-button>
        </div>
      </validation-observer>
    </modal-container>
  </modal-wrapper>
</template>

<script>
import PcButton from '@/components/common/PcButton.vue'
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import ModalWrapper from '@/components/modals/ModalWrapper'
import ModalContainer from '@/components/modals/ModalContainer'
import LanguageSwitcher from '@/components/common/LanguageSwitcher'
import TextInput from '@/components/inputs/TextInput'
import FormGroup from '@/components/views/RegisterPage/FormGroup'

export default {
  name: 'ResidentRegister',
  components: {
    FormGroup,
    TextInput,
    LanguageSwitcher,
    ModalContainer,
    ModalWrapper,
    ValidationObserver,
    ValidationProvider,
    PcButton
  },
  props: {
    backendErrors: {
      type: Object,
      default:() => {}
    }
  },
  emits:['start-register'],
  data() {
    return {
      phone: '',
      email: ''
    }
  },
  methods: {
    register(dataType) {
      const data = {
        email: this.email,
        phone: this.phone
      }

      this.$emit('start-register' ,data)
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/theme.scss";
@import "~@/assets/scss/views/register-common.scss";
h3 {
  font-size: 20px;
  padding-bottom: 30px;
}

.register-page__modal-buttons.vertical {
  padding-top: 60px;
}

.email-hint {
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  color: $gray-2;
}

</style>
